import { render } from "./HighlightText.vue?vue&type=template&id=4d424bf0"
import script from "./HighlightText.vue?vue&type=script&lang=js"
export * from "./HighlightText.vue?vue&type=script&lang=js"
script.render = render

export default script